import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const FileDotsIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 12, height = 12, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M7 1.5V3.5C7 3.63261 7.05268 3.75979 7.14645 3.85355C7.24022 3.94732 7.36739 4 7.5 4H9.5M7 1.5H3.5C3.23478 1.5 2.98043 1.60536 2.79289 1.79289C2.60536 1.98043 2.5 2.23478 2.5 2.5V9.5C2.5 9.76522 2.60536 10.0196 2.79289 10.2071C2.98043 10.3946 3.23478 10.5 3.5 10.5H8.5C8.76522 10.5 9.01957 10.3946 9.20711 10.2071C9.39464 10.0196 9.5 9.76522 9.5 9.5V4M7 1.5L9.5 4M4.5 7V7.005M6 7V7.005M7.5 7V7.005"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
